<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import VisitQuickActionButton from './VisitQuickActionButton.vue';
import { VISIT_DETAIL_TEXT } from '../utils/visitDetailPresenter';

const props = defineProps({
  canSendIntroduction: { type: Boolean, default: false },
  canSendOffer: { type: Boolean, default: false },
  canTalkToOwner: { type: Boolean, default: false },
  canTalkToVisitor: { type: Boolean, default: true },
  canOpenVisitor: { type: Boolean, default: false },
  canAddMore: { type: Boolean, default: true },
  allowedActions: { type: Array, default: () => [] },
});

const emit = defineEmits([
  'sendIntroduction',
  'sendOffer',
  'openVisitor',
  'talkOwner',
  'talkVisitor',
  'addMore',
  'openEntry',
]);

const ACTIONS_TITLE = 'Ações da visita';

const actionAllowed = actionKey =>
  !props.allowedActions.length || props.allowedActions.includes(actionKey);

const actions = computed(() =>
  [
    {
      key: 'sendIntroduction',
      label: VISIT_DETAIL_TEXT.SEND_PRESENTATION,
      icon: 'i-lucide-message-circle',
      disabled: !props.canSendIntroduction,
    },
    {
      key: 'sendOffer',
      label: VISIT_DETAIL_TEXT.SEND_OFFER_LINK,
      icon: 'i-lucide-file-signature',
      disabled: !props.canSendOffer,
    },
    {
      key: 'openVisitor',
      label: VISIT_DETAIL_TEXT.OPEN_VISITOR_PROFILE,
      icon: 'i-lucide-user-round-search',
      disabled: !props.canOpenVisitor,
    },
    {
      key: 'talkOwner',
      label: VISIT_DETAIL_TEXT.TALK_TO_OWNER,
      icon: 'i-lucide-user-round-cog',
      disabled: !props.canTalkToOwner,
    },
    {
      key: 'talkVisitor',
      label: VISIT_DETAIL_TEXT.TALK_TO_VISITOR,
      icon: 'i-lucide-phone',
      disabled: !props.canTalkToVisitor,
    },
    {
      key: 'addMore',
      label: VISIT_DETAIL_TEXT.ADD_MORE_VISITS,
      icon: 'i-lucide-calendar-plus',
      disabled: !props.canAddMore,
    },
    {
      key: 'openEntry',
      label: 'Entrada e chaves',
      icon: 'i-lucide-key-round',
    },
  ].filter(action => actionAllowed(action.key))
);

const trigger = action => {
  if (action.disabled) return;
  switch (action.key) {
    case 'sendIntroduction':
      emit('sendIntroduction');
      break;
    case 'sendOffer':
      emit('sendOffer');
      break;
    case 'openVisitor':
      emit('openVisitor');
      break;
    case 'talkOwner':
      emit('talkOwner');
      break;
    case 'talkVisitor':
      emit('talkVisitor');
      break;
    case 'addMore':
      emit('addMore');
      break;
    case 'openEntry':
      emit('openEntry');
      break;
    default:
      break;
  }
};
</script>

<template>
  <LaisCard :title="ACTIONS_TITLE" prefix-icon="i-lucide-bolt">
    <div class="grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
      <VisitQuickActionButton
        v-for="action in actions"
        :key="action.key"
        :label="action.label"
        :icon="action.icon"
        :disabled="action.disabled"
        mobile-sidebar-safe
        @click="trigger(action)"
      />
    </div>
  </LaisCard>
</template>
